// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RichText{margin-top:30px;margin-bottom:30px;line-height:2.6rem}.RichText h1,.RichText h2{line-height:1}.RichText h2{margin-top:50px;margin-bottom:20px}.RichText h3{margin:30px 0 20px 0;line-height:1}.RichText h4{margin:20px 0;line-height:1}.RichText h5{margin:15px 0;line-height:1}.RichText h6{margin:10px 0;line-height:1}.RichText ul{list-style:disc;padding-left:15px;margin:20px 0;line-height:16px}.RichText li{font-family:Roboto-Bold,sans-serif}", ""]);
// Exports
module.exports = exports;
